/**
 * @desc 入库单回传NS
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.inMasterPushNs.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/inMasterPushNs`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
